module.exports = __webpack_public_path__ + "img/icon-data05.87bcec97.png";